import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Button } from 'shared/ui'
import { useTextToSpeechContext } from 'widgets/TextToSpeech/context/context'
import { PlaySpeechBtn } from 'widgets/TextToSpeech/ui/TextToSpeechActions/PlaySpeechBtn/PlaySpeechBtn'
import { type ISpeechToTextVariant } from 'widgets/TextToSpeech/store/type'
import { MergeFieldBtn } from './MergeFieldBtn/MergeFieldBtn'
import styles from './styles.module.scss'

export type ITextToSpeechActionsProps = {
  variant?: ISpeechToTextVariant
  withMergeFields?: boolean
}

export const TextToSpeechActions = observer(
  ({ variant = 'inline', withMergeFields }: ITextToSpeechActionsProps) => {
    const { onCreate, isDisabledCreate, type } = useTextToSpeechContext()
    return (
      <div
        className={classNames(styles.wrap, {
          [styles.modal]: variant === 'modal',
        })}
      >
        {withMergeFields && <MergeFieldBtn />}
        <PlaySpeechBtn />
        {type === 'create' && variant !== 'modal' && (
          <Button
            size={'small'}
            disabled={isDisabledCreate}
            contained={'primary'}
            onClick={onCreate}
            text='Create'
          />
        )}
      </div>
    )
  }
)
